import React, { Component } from "react";

import "./HeaderBackground.component.scss";

export default class HeaderBackground extends Component {
    render() {
        return (
            <div id="HeaderBackground">
            </div>
        );
    }
}
